define([
	"dojo/_base/declare",
	"dojo/store/Memory",
	"csi/config",
	"csi/reflection",
	"SiteAdmin/DataSheetTable"
], function(declare, Memory, config, reflection, DataSheetTable) {

	return declare(DataSheetTable, {
		// String: url of root TestRunRevision node
		//urlTestRunRevision: null,

		// String: url of TestRunSection for which to show child Tests
		//urlTestRunSection: null,

		// Relationship: relationship swapped out when TestRunSection on the toolbar is switched
		//_revisionRelationship: null,
		//_sectionRelationship: null,

		/**
		 * @override
		 * Ensure that root node of view is the revision so that view is found, no matter what section is currently selected
		 */
		getCustomViewPreviewProps() {
			const props = this.inherited(arguments);
			props.nodeUrl = this.urlTestRunRevision;
			return props;
		},

		setViewNode: function(/*Node*/node, /*Boolean*/bSaveSelections) {
			// summary: swap relationships if view node type changes

			// if first time, store references to both root relationships
			if (!this._sectionRelationship) {
				var rels = this.defView.m_relationships;
				this._sectionRelationship = rels.shift();
				this._revisionRelationship = rels[0];

				// root node of view can switch between TestRunRevision and TestRunSection, but keep localization consistent
				this.defView.m_rcRoot = reflection.getClass("TestRunRevision");
			}

			if (!this.urlTestRunRevision && node && (node.$Type == "TestRunRevision")) {
				this.urlTestRunRevision = node.$URL;

				// if creating view, then initialize view with section if it exists, otherwise revision
				if (this.urlTestRunSection) {
					node = this.cacheView.getNode(this.urlTestRunSection);
				}
			}

			// change prefNodeContext to that of root node (if one)
			if (node) {
				this.prefNodeContext = config.getSubtypeName(node.TestSpecSubtype);
			}

			this.inherited(arguments, [node, bSaveSelections]);
		},

		getCustomViewNodeContextsStore: function() {
			// summary: return store of test types
			var p = this.toolbarNode.getPlugin("TestTypes");
			if (p) {
				var store = p.get("store");

				return new Memory({
					data: store.query(),
					idProperty: store.labelProperty,
					labelProperty: store.labelProperty,
					typeNode: "TestSpecSubtype"
				});
			}

			return null;
		},

		postActionNewTest: function(/*Controller*/ac) {
			// summary: reset type store used for custom views and refresh switchboard store
			var p = this.toolbarNode.getPlugin("TestTypes");
			if (p) {
				p.refreshStore();
			}
		},

		postActionSwitchboard: function(/*Controller*/ac) {
			// summary: refresh custom view store and default view
			return this.refreshDefaultCustomView(true);
		},

		_preView: function() {
			// summary: set appropriate relationship for view based on root node
			this.relRoot = this.defView.m_relationships[0] = this.prefNodeContext ? this._sectionRelationship : this._revisionRelationship;
			this.inherited(arguments);
		},

		_resolveView: function() {
			// summary: resolve swapped relationship - must be done after view root node is first set
			var rc = reflection.getClass("TestRunSection");
			this._sectionRelationship.key = 0;
			this._sectionRelationship.resolve(this.defView.getLocaleMap(rc), rc);
			this.inherited(arguments);
		}
	});
});